// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","socials":"Footer_socials__soOBA","socialLink":"Footer_socialLink__ZPpug","copyright":"Footer_copyright__Yoh4-"};